<template>

  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div class="flex flex-col">
      <div class="flex flex-col justify-center">

        <div class="font-semibold block text-center text-4xl mb-4">
          You have to sign in before accessing the room 😊
        </div>
        <div class="font-semibold block text-center text-4xl mb-4">
          <span class="text-blue-400 inline-block">{{ roomName }} </span> is running... 👀
        </div>
      </div>
      <div class="flex justify-center">
        <div
            class="inline-block bg-blue-400 bg-opacity-80 p-2 ml-2 w-4 h-4 rounded-full animate-bounce blue-circle"
        ></div>
        <div
            class="inline-block  bg-blue-400 bg-opacity-80 ml-2 p-2 w-4 h-4 rounded-full animate-bounce green-circle"
        ></div>
        <div
            class="inline-block  bg-blue-400 bg-opacity-80 p-2 ml-2 w-4 h-4 rounded-full animate-bounce red-circle"
        ></div>
      </div>

    </div>

    <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
      <login-form></login-form>
    </div>
  </div>

</template>

<script>

import LoginForm from "@/Pages/Auth/LoginForm";

export default {
  components: {
    LoginForm
  },
  props: ['roomName'],
  data() {
    return {};
  },
  mounted() {

  },

  methods: {},
};
</script>


<style scoped>
.blue-circle {
  animation-delay: 0.1s;
}

.green-circle {
  animation-delay: 0.2s;
}

.red-circle {
  animation-delay: 0.3s;
}

</style>